import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import ReadOnlyInput from '@features/supplier-onboarding/components/ReadOnlyInput';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import {
	useOnboardingStatus,
	useSupplierBankInfo
} from '@store/reducers/supplier-onboarding/OnboardingReducer';

import { approveOnboardingRequest, rejectOnboardingRequest } from '@services/supplierOnboardingService';

import { printApiError } from '@utils/Util';

const BankInformation = () => {
	const supplierBankInfo = useSupplierBankInfo();
	const onboardingStatus = useOnboardingStatus();
	const { id } = useParams();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const stepName = 'BANK_INFORMATION';

	const handleReject = async () => {
		try {
			dispatch(openLoader());
			await dispatch(rejectOnboardingRequest(id));
			dispatch(closeLoader());
		} catch (error) {
			printApiError(error);
			dispatch(closeLoader());
		}
	};

	const handleApproved = async () => {
		try {
			dispatch(openLoader());
			await dispatch(approveOnboardingRequest(id));
			dispatch(closeLoader());
			navigate(`/suppliers/view/${id}`);
		} catch (error) {
			printApiError(error);
			dispatch(closeLoader());
		}
	};

	return (
		<div className="information-form">
			<h3 className="title weight-700 gray_dark_01">Bank Information</h3>
			<div className="row">
				<div className="col-md-12">
					<ReadOnlyInput
						label="Bank Name"
						name="bankName"
						value={supplierBankInfo?.bankName}
						stepName={stepName}
					/>
				</div>
				<div className="col-md-12">
					<ReadOnlyInput
						label="Account Holder Name"
						name="title"
						value={supplierBankInfo?.title}
						stepName={stepName}
					/>
				</div>
				<div className="col-md-12">
					<ReadOnlyInput
						label="Account Number"
						name="accountNumber"
						value={supplierBankInfo?.accountNumber}
						stepName={stepName}
					/>
				</div>
				<div className="col-md-12">
					<ReadOnlyInput
						label="Swift Code"
						name="swiftCode"
						value={supplierBankInfo?.swiftCode}
						stepName={stepName}
					/>
				</div>
				<div className="col-md-12">
					<ReadOnlyInput
						label="Bank Address"
						name="bankDetails"
						value={supplierBankInfo?.bankDetails}
						stepName={stepName}
					/>
				</div>
				<div className="col-md-12">
					<ReadOnlyInput
						label="BIN Number"
						name="binNumber"
						value={supplierBankInfo?.binNumber}
						stepName={stepName}
					/>
				</div>
			</div>
			<div className="submit-button d-flex">
				<button
					disabled={
						onboardingStatus?.rejectedFieldList?.length === 0 ||
						onboardingStatus?.supplierOnboardingStatus === 'REJECTED'
					}
					className="button size32 w-50 mr-2"
					type="submit"
					onClick={handleReject}
				>
					Reject
				</button>
				<button
					className="button approve size32 w-50"
					disabled={onboardingStatus?.rejectedFieldList?.length > 0}
					onClick={handleApproved}
				>
					Approve
				</button>
			</div>
		</div>
	);
};

export default BankInformation;
